export const SHOP_POPUP_TYPE = {
  activateBuy: 'activateBuy',
  sellCrypto: 'sellCrypto',
  sellGiftCard: 'sellGiftCard',
  revealKey: 'revealKey',
  revealKeyPassword: 'revealKeyPassword',
  receiveCrypto: 'receiveCrypto',
  sendCrypto: 'sendCrypto'
}
